/** Components **/
import DefaultRangeFilterToolTip from './../../../components/Dashboards/Barometer/FilterToolTips/DefaultRangeFilterToolTip';
import TableHeaderTitleWithPicto from './../../../components/Dashboards/Barometer/TableHeaders/TitleWithPicto';
import DefaultSumTotalCell from './../../../components/Dashboards/Barometer/TableTotalCells/DefaultSumTotalCell';
import TableCellGSC from './../../../components/Dashboards/Barometer/TableCells/GSC';
import GSCFilterToolTip from './../../../components/Dashboards/Barometer/FilterToolTips/GSCFilterToolTip';

export const GscImpressionsColumn = ( barometerContext, widthColumns ) => 
{
  return {
    accessor: "gsc.impressions",
    width: widthColumns["impressions"],
    title: "impressions",
    className: "col-gsc",          
    Filter: (
      barometerContext === 'keywords' 
      || barometerContext === 'gsc-keywords'
    ) ? 
      GSCFilterToolTip 
      : DefaultRangeFilterToolTip,
    filter: 'multiFieldsCustomFilter',
    filterTitle: 'volume d\'impression',
    sortDescFirst: true,          
    sortType: 'valueSort',
    Header: props => 
      <TableHeaderTitleWithPicto id={props.column.id} title={props.column.title} />,
    Total: props => 
      <DefaultSumTotalCell id={props.column.id} />,
    Cell: props => 
      <TableCellGSC 
        id={props.cell.row.id}
        values={props.value} 
        accessor={props.column.id} 
        label={props.cell.row.values.label}
        keywords={props.cell.row.original.keywords}
      />
  }
}